import React from "react";

export default function Link(props) {
  return (
    <>
      <a
        href={props.link}
        className={props.className}
        title={props.title}
        target={props.target}
      >
        {props.children}
      </a>
    </>
  );
}
